module.exports = {
	"articleTitle1": "Collage Concert comes to Hill Auditorium ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Hill Auditorium",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/news/concert-featuring-matisyahu-nadim-azzam-aims-promote-unity",
	"articleSnippet1": "Collage Concert comes to Hill Auditorium. Allie Taylor. Daily Arts Writer. \nWednesday, January 11, 2017 - 7:20pm ...",
	"articleSnippet2": "Mar 15, 2016 ... Reggae artist Matisyahu will touch on several themes relevant to current campus \ndiscourse in his performance April 4 at Hill Auditorium, ...",
	"totalMisc": 0,
	"articleTitle2": "Concert at Hill Auditorium featuring Matisyahu, Nadim Azzam aims ...",
	"address": "825 N University Ave, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160323/gbh.NEW_.NeildeGrasseTyson.3.23.16.197.jpg?itok=n5UI_f1K",
			"author": "Grant Hardy",
			"caption": "Neil deGrasse Tyson PhD, head of the Hayden Planetarium, discusses the cosmic perspective –which views humans as significant for not being separate from the universe, but rather as a part of it –in Hill Auditorium on Wednesday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160414/zem.Migos_.4.13.16.0349.jpg?itok=QhTcwDkG",
			"author": "Zach Moore",
			"caption": "Migos member Offset performs for Spring Fest hosted by Music Matters at Hill Auditorium Wednesday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170119/msk.NEW_.KeynoteSpeakerMLK.1.16.17.149.jpg?itok=g_fSHrAi",
			"author": "Max Kuang",
			"caption": "Issa Rae, creator of The Misadventures of Awkward Black Girl, talks about her path to success at the annual Dr. Martin Luther King Jr. Symposium at Hill Auditorium on Monday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170119/msk.NEW_.KeynoteSpeakerMLK.1.16.17.305.jpg?itok=5Rga0epC",
			"author": "Max Kuang",
			"caption": "Chloe Arnold, Assata Madison, and Orialis Ashley from the Syncopated Ladies perform at the annual Dr. Martin Luther King Jr. Symposium at Hill Auditorium on Monday."
		}
	],
	"position": {
		"lat": 42.2791,
		"lng": -83.739
	},
	"tips": [
		{
			"text": "The auditorium may be one of the most beautiful places on campus.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [],
	"categories": {
		"livemusic": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/hillauditorium.json
// module id = 891
// module chunks = 0